const handlePathname = pathname => {
  const pathWithoutDigitalRoute = pathname.replace('/digital', '')
  const [, country] = pathWithoutDigitalRoute.split('/')
  const pathWithoutCountry = pathWithoutDigitalRoute.replace(/([a-z]{2})\//, '')

  return { path: pathWithoutCountry, country }
}

export default handlePathname
